import { render, staticRenderFns } from "./check_curriculum.vue?vue&type=template&id=5721adba&"
import script from "./check_curriculum.vue?vue&type=script&lang=js&"
export * from "./check_curriculum.vue?vue&type=script&lang=js&"
import style0 from "./check_curriculum.vue?vue&type=style&index=0&id=5721adba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports